"use client";

import { Box, TablePagination } from "@mui/material";
import type { Table } from "@tanstack/react-table";
import type * as React from "react";

type DataTablePaginationProps<TData> = {
  table: Table<TData>;
  pageSizeOptions?: number[];
  totalCount?: number;
} & React.ComponentProps<"div">;

export function DataTablePagination<TData>({
  table,
  pageSizeOptions = [10, 20, 30, 40, 50],
  className,
  totalCount,
  ...props
}: DataTablePaginationProps<TData>) {
  const { pageIndex, pageSize } = table.getState().pagination;

  return (
    <Box
      className={className}
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 1,
        p: 0.5,
      }}
      {...props}
    >
      {/* <Typography color="text.secondary" sx={{ flex: 1, fontSize: 14 }}>
        {selectedCount}
        {" "}
        of
        {" "}
        {" "}
        {totalFiltered}
        {" "}
        row(s) selected.
      </Typography> */}
      <TablePagination
        component="div"
        count={typeof totalCount === "number" ? totalCount : -1}
        onPageChange={(_, nextPage) => table.setPageIndex(nextPage)}
        onRowsPerPageChange={(event) => {
          table.setPagination({ pageIndex: 0, pageSize: Number(event.target.value) });
        }}
        page={pageIndex}
        rowsPerPage={pageSize}
        rowsPerPageOptions={pageSizeOptions}
        showFirstButton
        showLastButton
        sx={{
          ".MuiTablePagination-toolbar": { minHeight: 40, pl: 0, pr: 0 },
          ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": { fontSize: 14 },
        }}
      />
    </Box>
  );
}
